import React, { useEffect } from "react"; 
import { useNavigate } from "react-router-dom";  
import Loader from "../../components/loader";
import { logout } from "../../reducers/authReducer";
import { useAppDispatch } from "../../hooks/useAppDispatch";

const Logout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(logout());
    navigate("/Signin", { replace: true });
  }, [dispatch, navigate]);

  return <Loader />;
};

export default Logout;
